import ListKeyFiguresByCompanyTypeBox from './ListKeyFiguresByCompanyTypeBox'

export default ListKeyFiguresByCompanyTypeBox
